<template>
  <div class="dashboard-container" fluid>
    <TheHero />
    <AppBorderedSection
      :sectionNumber="0"
      class="section-step pb-6"
      id="section-0"
    >
      <TheSectionIntro />
    </AppBorderedSection>
    <AppBorderedSection
      :sectionNumber="1"
      :mainSection="true"
      class="section-step pb-12"
      id="section-1"
    >
      <TheSectionWho :sectionNumber="1" />
    </AppBorderedSection>
    <AppBorderedSection
      :sectionNumber="2"
      :mainSection="true"
      class="section-step pb-12"
      id="section-2"
    >
      <TheSectionWhat :sectionNumber="2" />
    </AppBorderedSection>
    <AppBorderedSection
      :sectionNumber="3"
      :mainSection="true"
      class="section-step pb-12"
      id="section-3"
    >
      <TheSectionHow :sectionNumber="3" />
    </AppBorderedSection>
    <AppBorderedSection
      :sectionNumber="0"
      :mainSection="true"
      class="section-step pb-6"
      id="section-0"
    >
      <TheSectionOutro />
    </AppBorderedSection>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "intersection-observer";
import scrollama from "scrollama";
import AppBorderedSection from "@/components/AppBorderedSection.vue";
import TheHero from "./TheHero.vue";
import TheSectionIntro from "./TheSectionIntro.vue";
import TheSectionWho from "./TheSectionWho.vue";
import TheSectionWhat from "./TheSectionWhat.vue";
import TheSectionHow from "./TheSectionHow.vue";
import TheSectionOutro from "./TheSectionOutro.vue";
export default {
  components: {
    TheHero,
    TheSectionIntro,
    TheSectionWho,
    TheSectionWhat,
    TheSectionHow,
    TheSectionOutro,
    AppBorderedSection
  },
  data() {
    return {
      scroller: scrollama(),
      offset: 0
    };
  },
  mounted() {
    this.updateOffset();
    this.scroller
      .setup({
        step: ".section-step",
        offset: this.offset
      })
      .onStepEnter(({ element, index, direction }) => {
        this.updateCurrentSection(index);
      });

    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    if (this.scrollama) {
      this.scrollama.destroy();
    }
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions(["updateCurrentSection"]),
    updateOffset() {
      this.offset = 49 / window.innerHeight;
    },
    onResize() {
      this.updateOffset();
      this.scroller.offsetTrigger(this.offset);
      this.scroller.resize();
    }
  }
};
</script>
